import Aside from './src/aside';

Aside.install = function(Vue) {
  Vue.component(Aside.name, Aside);
};

export default Aside;



// WEBPACK FOOTER //
// ./src/components/aside/index.js